import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as apiUtility from '../../config/APIUtils';

const BASE_URL_EMAIL_TO_EMPLOYER = "user/sendEmailEmp";
const BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED = "course/getAllCourseVersion_forUser";

/***
 * 
 * @param {{}} [userData={}] 
 * @param {[]} [courseData=[]] 
 * @param {{}} [trainingProviders={}]
 * @param {string} [reportName=''] 
 * @param {string} [fileName=''] 
 * @param {boolean} [isEmail=false] 
 * 
 */
export async function CoursePdfReport(userData = {}, courseData = [], trainingProviders={}, reportName = '', fileName = '', isEmail = false, reportType=1) {
    try {

        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";
        const compress = true;
        const fontSize = 8;
        const lineHeight = 1;
        const autoSize = false;
        const printHeaders = true;

        const doc = new jsPDF(orientation, unit, size, compress, fontSize, lineHeight, autoSize, printHeaders);
        doc.setFontSize(15);
        const title = "Care Passport\n"+reportName;
                                   
                         
                        
        var userBody = [{}];
        var userHeader = [{}];

        let courseStr = (reportType === 2 && courseData?.length > 0) ? "Course Code : "+courseData[0].course_id : " ";

        userHeader = [{ 'first': 'Name : ' + userData.firstName + " " + userData.lastName, 'sec': ' ' }];
        userBody = [{ 'first': 'UserId : ' + userData.user_id, 'sec': 'Home : ' + userData.homeName },
        { 'first': 'Date Of Birth : ' + userData.dob, 'sec': 'Role : ' + userData.roleName },
        { 'first': 'Date : ' + new Date().toLocaleString(), 'sec': courseStr }]

        const lineColor = '#cccccc';
        const titleHeight = 55;
        const infoHeaderHeight = 150;

        doc.setDrawColor(lineColor);
        
        const pageWidth = doc.internal.pageSize.getWidth() - 20;
        doc.rect(40, 20, pageWidth - 60, titleHeight);
        doc.rect(40, 20, pageWidth - 60, infoHeaderHeight);

        autoTable(doc, {
            head: userHeader,
            body: userBody,
            styles: { font: 'helvetica', cellWidth: 'wrap' },
            startY: 80,
            theme: 'plain'
        });

        let totalHeight = titleHeight+infoHeaderHeight+15;

        let courseCodeHeaderStr = (reportType === 2) ? "Course Version Code" : "Course Code";

        let headers = [[courseCodeHeaderStr, 'Title', 'Training Provider', 'Course Status', 'Expiry Date']];
        let tableData = [];
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED;
        apiRequest.data = {
            "courses": courseData,
            "userId": userData.user_id
        };

        if(reportType === undefined || reportType === 1){
            await apiUtility.sendAPIDataPOST(apiRequest).then(response => {
                        for (let item of response.data) {
                            let courseVersion = [
                                item.crsId,
                                item.title,
                                item.orgIssued ? trainingProviders?.[parseInt(item.orgIssued)] : '',
                                item.equivalentCrsStatus,
                                item.validity
                            ];
                            tableData.push(courseVersion);
                        }
                    }).catch(error => {
                        return {code:500 , message: "Error while processing courses."};
            });
        } else if(reportType === 2){
            for (let item of courseData) {
                let courseVersion = [
                    item.courseVersion.tp_course_code,
                    item.courseVersion.title,
                    item.courseVersion.training_provider_id ? trainingProviders?.[parseInt(item.courseVersion.training_provider_id)] : '',
                    item.verification,
                    item.expiry_date
                ];
                tableData.push(courseVersion);
            }
        }

       

        let content = {
            startY: doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : totalHeight,
            styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },//, fillColor: [0, 255, 0]}}, // Cells in first column centered and green
            headStyles: {
                fillColor: [0, 102, 153], halign: 'center'
            },
            margin: { top: 30 },
            head: headers,
            body: tableData,
            theme: 'grid'
        };
        autoTable(doc, content);

        
        doc.setProperties({
            title: title,
            subject: 'Carepasport auto generated reports',
            author: 'Carepassport',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Carepassport',
            bodyStyles: {
                color: '#cccccc'
            }
        });
        doc.setFontSize(15);
        doc.text(title, 300, 40, {
            align: 'center'
        });
        
        if (isEmail) {
            let blob = doc.output('blob');
            let data = new FormData();
            data.append("userId", userData.user_id);
            data.append("emailId", userData.empEmailId);
            data.append("subject", "Carepassport - "+reportName);
            data.append("reportName", fileName);
            data.append("file", blob);
            data.append("type", "PDF");
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_EMAIL_TO_EMPLOYER;
            apiRequest.data = data;
            apiUtility.sendAPIDataPOST(apiRequest)
                .then(response => {
                    return {code:200 , message: response.data};
                }).catch(error => {
                    return {code:500 , message: "Error while sending email"};
                });
        } else {
            doc.save(fileName !== '' ? fileName + ".pdf" : "Carepassport_" + userData.user_id + ".pdf");
            return {code:200 , message: 'File downloaded successfully'};
        }
    } catch (error) {
        console.log("error : ", error);        
        return {code:200 , message: error};
    }
}